var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4,
    width: 12,
    height: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.45 1 1.5 5.95 1.5 12C1.5 18.05 6.45 23 12.5 23C18.55 23 23.5 18.05 23.5 12C23.5 5.95 18.55 1 12.5 1ZM11.6357 5.71429H13.3643V14.3571H11.6357V5.71429ZM12.5 19.0714C11.8714 19.0714 11.3214 18.5214 11.3214 17.8929C11.3214 17.2643 11.8714 16.7143 12.5 16.7143C13.1286 16.7143 13.6786 17.2643 13.6786 17.8929C13.6786 18.5214 13.1286 19.0714 12.5 19.0714Z",
    fill: "#F1C21B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.5eb399b7173e4cb2527ed116a9731ea1.svg";
export { ForwardRef as ReactComponent };